// extracted by mini-css-extract-plugin
export default {"textBox":"Text_textBox__7SJNP","textHeader":"Text_textHeader__NY5HT","textContent":"Text_textContent__gq-ed"};